import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function NewCarvingsPage() {
  return <ProductPageContent data={PRODUCT_PAGES["new-carvings"]} />;
}

export default NewCarvingsPage;
